import { EntityTabs } from '../../../constants/entity-tabs';

export const CreateEntityRoutes = {
  [EntityTabs.Accommodation]: '/accommodations/create',
  [EntityTabs.Activities]: '/activities/create'
};

export const CreateButtonContent = {
  [EntityTabs.Accommodation]: 'New Accommodation',
  [EntityTabs.Activities]: 'New Activity'
};
